<template><!-- svgo-optimised -->
<svg class="icon icon__play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4.468 20.223A1 1 0 0 1 3 19.339V4.661a1 1 0 0 1 1.468-.884l13.863 7.34a1 1 0 0 1 0 1.767L4.468 20.223Z"/></svg>
</template>